<template>
  <div>
    <router-link :to="{ name: 'main' }" class="text-red-600 mb-4 absolute pin-t pin-l pl-8 pt-4"><arrow-left-icon></arrow-left-icon> Go Back</router-link>

    <div class="form-wrapper">
        <h3 class="font-serif font-bold text-4xl text-black mb-4 text-center">
			{{ title }}
		</h3>  

        <slot name="main"></slot>
    </div>
  </div>
</template>

<script>
import { ArrowLeftIcon } from "vue-feather-icons";

export default {
  name: "FormTemplate",
  props: {
    title: String
  },
  components: { ArrowLeftIcon }
};
</script>

<style lang="scss" scoped>
.form-wrapper {
  display: flex;
  flex-direction: column;
  background: transparent;
  /* padding: 40px 50px; */
  width: 100%;
  border-radius: 5px;
  border: 0.5px solid#F6FAFD;
  font-family: Bitter, Georgia, Cambria, "Times New Roman", Times, serif;
}

.back {
  color: #e53e3e;
  cursor: pointer;
  margin-bottom: 5px;
  text-decoration: underline;
}
</style>
